module.exports = __webpack_public_path__ + "img/jumpilla-1.21d5b8e2.jpg";